<template>
  <div
    class="tw-mt-6 tw-box-border tw-flex tw-flex-row tw-space-x-4 tw-rounded-lg tw-border-2 tw-border-green-700 tw-bg-green-50 tw-p-4"
  >
    <img
      :src="asset('/assets/site/images/svg/google.svg')"
      class="tw-h-9 tw-min-h-[2.25rem] tw-w-9 tw-min-w-[2.25rem]"
      alt="Google"
    />

    <div class="tw-flex tw-flex-col tw-text-green-700">
      <div class="tw-font-semibold">Google reviews</div>
      <div class="tw-mt-1 tw-space-y-4 tw-text-sm">
        <p>All reviews are provided by Google customers who have submitted their review into the Google platform.</p>
      </div>
    </div>
  </div>
</template>
